import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from '../../Compliance/WeissmanModalService';

export interface ClientPaymentApproverBulkResultModalParams {
    result: Core.PaymentBatchBulkUpdateApproverResultModel;
}

@Component({
    selector: 'client-payment-approver-bulk-result-modal',
    templateUrl: './clientPaymentApproverBulkResultModal.component.html',
    standalone: false,
})
export class ClientPaymentApproverBulkResultModalComponent
    implements IWeissmanModalComponent<ClientPaymentApproverBulkResultModalParams, void> {

    constructor(private readonly bsModalRef: BsModalRef) {}

    params: ClientPaymentApproverBulkResultModalParams;
    result: void;

    get successCount(): number {
        return this.params?.result?.successCount ?? 0;
    }

    get failures(): Core.PaymentBatchBulkUpdateApproverFailureModel[] {
        return this.params?.result?.failures ?? [];
    }

    get hasFailures(): boolean {
        return this.failures.length > 0;
    }

    close(): void {
        this.bsModalRef.hide();
    }
}
